import type { MouseEvent } from "react";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";
import type { DrivingSchoolAutoForm } from "../../providers/autoFormsProvider";

export function AutoFormMobileListItem(props: {
  autoForm: DrivingSchoolAutoForm;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  showRegistrationStatus?: boolean;
}) {
  const { autoForm, onClick, showRegistrationStatus = false } = props;
  const theme = useTheme();

  return (
    <ButtonBase
      component="div"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Column sx={{ alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
          {autoForm.name}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
          {autoForm.description || "—"}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
          PDF-Vorlage: {autoForm.pdfTemplateBaseFile.fileName}
        </Typography>
        {showRegistrationStatus && (
          <Typography variant="caption" color="text.secondary">
            Bei Anmeldung ausfüllen: {autoForm.isForRegistration ? "Ja" : "Nein"}
          </Typography>
        )}
      </Column>
    </ButtonBase>
  );
}
